<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">Listagem de Máquinass</p>
    </div>

    <section class="row">
      <div class="q-mt-sm col-md-2">
        <lista-unidades-select v-model="unidade"></lista-unidades-select>
      </div>
      <div class="col-md-2 col-2 q-mt-sm q-ml-sm">
        <q-select
          dense
          outlined
          v-model="tipo"
          :options="options"
          label="Tipo"
          :option-label="
            (opt) => (Object(opt) === opt && 'nome' in opt ? opt.nome : '')
          "
          :rules="[(val) => val || 'Campo Obrigatório']"
        >
          <template v-slot:prepend>
            <q-icon name="place" />
          </template>
        </q-select>
      </div>

      <div
        v-if="
          tipo.value == 'maquina' ||
          tipo.value == 'balcao' ||
          tipo.value == 'armario'
        "
        class="col-md-2 col-2 q-mt-sm q-ml-sm"
      >
        <q-input dense outlined label="Localização" v-model="localizacao" />
      </div>
      <div
        v-if="tipo.value == 'maquina'"
        class="col-md-2 col-2 q-mt-sm q-ml-sm"
      >
        <q-input
          dense
          outlined
          label="Bandejas"
          v-model="trays"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div
        v-if="tipo.value == 'maquina'"
        class="col-md-2 col-2 q-mt-sm q-ml-sm"
      >
        <q-input
          dense
          outlined
          label="Posições por Bandeja:"
          v-model="columnss"
          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
        />
      </div>
      <div class="q-mt-sm q-ml-sm">
        <q-btn
          @click="criarMaquina"
          color="positive"
          label="Criar Nova Maquina"
          icon="add"
          no-caps
          class="q-ml-sm"
        />
      </div>
    </section>

    <div class="q-pt-md">
      <q-table
        flat
        dense
        table-header-class="bg-accent text-width-bold"
        :filter="filter"
        title="Todas as máquinas do sistema"
        :rows="rows"
        :columns="columns"
        class="tabela-tamanho-fixo"
        :loading="disable"
        hide-pagination
        :rows-per-page-options="[0]"
      >
        <template #body-cell-ativar="props">
          <q-td>
            <q-toggle
              v-model="value"
              :val="props.row.id"
              color="primary"
              @click="ativar(props.row.id, $event)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "location",
    label: "Local",
    field: "location",
    align: "left",
  },
  {
    name: "id",
    label: "ID",
    field: "id",
    align: "left",
  },
  {
    name: "name",
    label: "Login",
    field: (row) => row.usuario_maquina.matricula,
    align: "left",
  },
];

import { ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import ListaUnidadesSelect from "../../../organizacional/unidade/component/ListaUnidadesSelect.vue";
export default {
  components: { ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const tipo = ref("");
    const disable = ref(true);
    const unidade = ref();
    const selected = ref(0);
    const value = ref([]);
    const $q = useQuasar();
    const localizacao = ref("");
    const filter = ref("");
    const columnss = ref("");
    const trays = ref("");
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 15,
    });

    const getMachine = async () => {
      const response = await store.dispatch("adminMultpex/getMachine", {
        vendor_id: store.state.org.unidadeData.id,
      });

      rows.value = response.data.results;
      disable.value = false;
    };

    onMounted(getMachine);

    const criarMaquina = async () => {
      try {
        await store.dispatch("adminMultpex/setMachine", {
          vendor_id: store.state.org.unidadeData.id,
          columns: +columnss.value,
          location: localizacao.value,
          trays: +trays.value,
          type: tipo.value.value,
        });

        $q.notify({
          message: "Criado com sucesso!",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        getMachine();
      } catch (error) {
        $q.notify({
          message: "Erro a o criar",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    watch(
      () => store.state.org.unidadeData,
      () => {
        if (store.state.org.unidadeData == null) {
          return;
        }
        unidade.value = store.state.org.unidadeData;
        getMachine();
      }
    );

    return {
      pagination,
      rows,
      options: [
        { nome: "Balcão", value: "balcao" },
        { nome: "Máquina", value: "maquina" },
        { nome: "Armário", value: "armario" },
      ],
      disable,
      columns,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      selected,
      tipo,
      unidade,
      value,
      criarMaquina,
      localizacao,
      filter,
      columnss,
      trays,
    };
  },
};
</script>
